/* eslint-disable */
class CharaBase {
  constructor(scene) {
    this.scene = scene;
    this.animationGroups = {};
    this.mesh;

    this.setupMeshs();
  }

  //------------------------------------
  // Setup Mesh
  //------------------------------------
  setupMeshs() {}

  update() {}

  //------------------------------------
  // ChangeTransform
  //------------------------------------
  changePosition(position, speed) {
    this.position = position;
    this.positionSpeed = speed;
  }

  //------------------------------------
  // Animation
  //------------------------------------
  setAnimationGroup(name, group) {
    this.animationGroups[name] = group;
    this.animationGroups[name].stop();
  }

  stopAnimationGroup(name) {
    this.animationGroups[name].stop();
  }

  startAnimation(name, loop) {
    if (this.animationName) {
      this.animationGroups[this.animationName].stop();
      this.animationGroups[this.animationName].reset();
    }

    this.animationGroups[name].start(loop);
    this.animationName = name;
  }

  //------------------------------------
  // Get
  //------------------------------------
  getMesh() {
    return this.mesh;
  }
}
export default CharaBase;
